import {
  CLEAR_DOCUMENT_PROPS_SUCCESS,
  CREATE_MANPOWER_SUCCESS,
  DOWNLOAD_PROGRESS,
  FETCH_ASSET_CODE_SUCCESS, FETCH_ASSET_FILTERS_SUCCESS,
  FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS,
  FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS,
  FETCH_DOCUMENT_TYPE_REPORT_SUCCESS,
  FETCH_ERROR,
  FETCH_FILTER_SUCCESS, FETCH_GLOBAL_ASSET_SEARCH_END, FETCH_GLOBAL_ASSET_SEARCH_START,
  FETCH_GLOBAL_SEARCH_END,
  FETCH_GLOBAL_SEARCH_START,
  FETCH_MASTER_FILTER_SUCCESS,
  FETCH_MODULE_SUCCESS, FETCH_PAGE_FIELDS_FILTER_SUCCESS, FETCH_PAGE_SETTING_FILTER_SUCCESS,
  FETCH_RELATIONSHIP_SEARCH,
  FETCH_START,
  FETCH_SUB_DOCUMENT_FILTER_SUCCESS,
  FETCH_SUB_ELEMENT_FILTER_SUCCESS,
  FETCH_SUB_MASTER_FILTER_SUCCESS,
  FETCH_SUCCESS,
  FETCH_SUPER_MASTER_FILTER_SUCCESS,
  FETCH_SUPER_START, GET_APPLICATION_MODULE_SUCCESS,
  GET_ASSET_PARAMETER_SEARCH_SUCCESS,
  GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS, GET_BACKGROUND_JOB_SUCCESS, GET_GLOBAL_ASSET_SEARCH_SUCCESS,
  GET_GLOBAL_PARAMETER_SEARCH_SUCCESS,
  HIDE_MESSAGE, PAGE_SETTING_FORM_VISIBLE_TOGGLE,
  QR_ALREADY_USED_CHECKED,
  SAVE_RELATIONSHIP_SEARCH,
  SHOW_MESSAGE,
  FETCH_DATA_START,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR
} from "../../constants/ActionTypes";

import axios from 'util/Api'
// import {createResourceSuccess} from "./Manpower";
import { message } from "antd";
// import {getErrorMessage} from "../../util/methods";

export const fetchStart = () => {
  return {
    type: FETCH_START
  }
};

export const fetchGlobalSearchStart = () => {
  return {
    type: FETCH_GLOBAL_SEARCH_START
  }
};

export const fetchGlobalSearchEnd = () => {
  return {
    type: FETCH_GLOBAL_SEARCH_END
  }
};

export const fetchGlobalAssetSearchStart = () => {
  return {
    type: FETCH_GLOBAL_ASSET_SEARCH_START
  }
};

export const fetchGlobalAssetSearchEnd = () => {
  return {
    type: FETCH_GLOBAL_ASSET_SEARCH_END
  }
};


export const fetchSuperStart = () => {
  return {
    type: FETCH_SUPER_START
  }
};

export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS
  }
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error
  }
};

export const fetchDataStart = () => {
  return {
    type: FETCH_DATA_START
  }
};

export const fetchDataSuccess = (data) => {
  return {
    type: FETCH_DATA_SUCCESS,
    payload: data
  }
};

export const fetchDataError = (error) => {
  return {
    type: FETCH_DATA_ERROR,
    payload: error
  }
};

export const downloadProgress = (total, download) => {
  return {
    type: DOWNLOAD_PROGRESS,
    total,
    download
  }
};


export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};

export const fetchFilterSuccess = (data) => {
  return {
    type: FETCH_FILTER_SUCCESS,
    data
  }
};

export const fetchPageSettingFilterSuccess = (data) => {
  return {
    type: FETCH_PAGE_SETTING_FILTER_SUCCESS,
    data
  }
};

export const fetchSubDocumentFilterSuccess = (data) => {
  return {
    type: FETCH_SUB_DOCUMENT_FILTER_SUCCESS,
    data
  }
};

export const fetchSubElementFilterSuccess = (data) => {
  return {
    type: FETCH_SUB_ELEMENT_FILTER_SUCCESS,
    data
  }
};

export const fetchPageFieldsFilterSuccess = (data) => {
  return {
    type: FETCH_PAGE_FIELDS_FILTER_SUCCESS,
    data
  }
};

export const fetchMasterFilterSuccess = (data) => {
  return {
    type: FETCH_MASTER_FILTER_SUCCESS,
    data
  }
};

export const fetchSubMasterFilterSuccess = (data) => {
  return {
    type: FETCH_SUB_MASTER_FILTER_SUCCESS,
    data
  }
};

export const clearDocumentReportProps = (data) => {
  return {
    type: CLEAR_DOCUMENT_PROPS_SUCCESS,
    data
  }
};

export const fetchSuperMasterFilterSuccess = (data) => {
  return {
    type: FETCH_SUPER_MASTER_FILTER_SUCCESS,
    data
  }
};


export const fetchModuleSuccess = (data) => {
  return {
    type: FETCH_MODULE_SUCCESS,
    data
  }
};

export const fetchDocumentAssetReportDataSuccess = (data) => {
  return {
    type: FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS,
    data,
  }
};

export const fetchAllFiltersDataSuccess = (data) => {
  return {
    type: FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS,
    data
  }
}

export const fetchAssetCodeSuccess = (data) => {
  return {
    type: FETCH_ASSET_CODE_SUCCESS,
    data
  }
};

export const fetchDocumentTypeSuccess = (data) => {
  return {
    type: FETCH_DOCUMENT_TYPE_REPORT_SUCCESS,
    data
  }
};

export const togglePageSettingVisibleSuccess = () => {
  return {
    type: PAGE_SETTING_FORM_VISIBLE_TOGGLE,
  }
};

export const togglePageSettingVisible = () => {
  console.log('setting btn clicked')
  return async (dispatch) => {
    dispatch(togglePageSettingVisibleSuccess())
  }
}

export const fetchDocumentAssetReportData = (payload) => {
  // console.log(payload);
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/common/document-asset-report`, payload);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(fetchDocumentAssetReportDataSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchPageSettingFilter = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=PageSetting`);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(fetchPageSettingFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchFilter = (module) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      if (response && response.data && module === 'Asset') {
        response.data['invoiceDate'] = {
          field: "invoiceDate",
          options: { required: false, disabledOnEdit: true, hidden: true },
          required: false,
          type: "Date",
        };
        response.data['invoiceValue'] = {
          field: "invoiceValue",
          options: { required: false, disabledOnEdit: true, hidden: true },
          required: false,
          type: "Number",
        }
      }
      dispatch(fetchFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchAssetCodes = (location, client, subType, assetType, assetCode) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let payload = {};
      let formData = new FormData();
      payload.location = location;
      payload.client = client;
      payload.subType = subType;
      payload.assetType = assetType;
      payload.assetCode = assetCode;
      Object.keys(payload).forEach(key => {
        if (payload[key] !== null) {
          formData.append(key, JSON.stringify(payload[key]));
        }
      });
      const response = await axios.post('/common/assetCodes', formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      dispatch(fetchAssetCodeSuccess(response['data']['data']));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchDocumentType = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // let formData = new FormData();
      // Object.keys(data).forEach(key => {
      //   if(data[key] !== null) {
      //     formData.append(key, JSON.stringify(data[key]));
      //   }
      // });
      // const response = await axios.post('/common/documentType', data);
      const response = await axios.get(`/common/schema?model=${'DocumentType'}`);
      console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(fetchDocumentTypeSuccess(response.data || []));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
}

export const fetchAllFiltersData = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/document-report-filters`);
      dispatch(fetchSuccess());
      dispatch(fetchAllFiltersDataSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchSubDocumentFilter = (module) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      dispatch(fetchSubDocumentFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchSuperMasterFilter = (module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      dispatch(fetchSuperMasterFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchMasterFilter = (module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(fetchMasterFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchSubMasterFilter = (module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      dispatch(fetchSubMasterFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchSubElementFilter = (module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      dispatch(fetchSubElementFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchPageFieldsFilter = (module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      dispatch(fetchSuccess());
      dispatch(fetchPageFieldsFilterSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const fetchModules = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/common/modules`);
      dispatch(fetchSuccess());
      dispatch(fetchModuleSuccess(response.data));
    } catch (error) {
      if (error.response) {
        dispatch(fetchError(error.response.data.message));
        console.log("Error****:", error.response.data.message);
      }
    }
  }
};

export const fetchRelationshipSearchSuccess = (data) => {
  return {
    type: SAVE_RELATIONSHIP_SEARCH,
    data
  }
};

export const fetchRelationshipSearch = (data) => {
  return {
    type: FETCH_RELATIONSHIP_SEARCH,
    data
  }
};

export const fetchRelationshipSearchData = (searchValue, model, field, type = 'search') => {
  // console.log(searchValue, model, field);
  return async (dispatch) => {

    if (field === 'name') {
      let searchOriginalString = searchValue;
      searchOriginalString = searchOriginalString.replace(/[^a-zA-Z0-9-./#]/g, '');
      searchValue = searchOriginalString;
    }

    dispatch(fetchStart());
    try {
      if (field === 'presentStatus') {
        field = 'changeStatus';
      }
      const response = await axios.get(`/common/search?searchValue=${searchValue}&model=${model}&field=${field}&type=${type}`);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(fetchRelationshipSearchSuccess(response.data.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createManpowerResourceSuccess = ({ data }) => {
  return {
    type: CREATE_MANPOWER_SUCCESS,
    data
  };
};

export const createResource = (payload, path, module) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/${path}`, payload);
      dispatch(createManpowerResourceSuccess({ data: response.data }));
      dispatch(fetchFilter(module));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getAssetSpareIssueReport = (typeId, type) => {
  // console.log(type, typeId);
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/asset-spare-issue/${type}/${typeId}`);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(getAssetSpareIssueReportSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getAssetSpareIssueReportSuccess = (data) => {
  return {
    type: GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS,
    data
  }
};

export const checkQrAlreadyUsed = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/check-qr-used/${id}`);
      dispatch(fetchSuccess());
      // console.log(response);
      if (response && response.status === 200) {
        dispatch(qrAlreadyUsedCheckedDone({ id, status: JSON.parse(response.data) }));
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const qrAlreadyUsedCheckedDone = ({ id, status }) => {
  return {
    type: QR_ALREADY_USED_CHECKED,
    id, status
  }
}

export const searchAssetParameter = (keyword) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/asset-parameter-search/${keyword}`);
      // console.log(response.data);
      dispatch(getSearchParameterSuccess(response));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getSearchParameterSuccess = ({ data }) => {
  return {
    type: GET_ASSET_PARAMETER_SEARCH_SUCCESS,
    data
  };
};

export const searchGlobalData = (keyword = '') => {
  // console.log(keyword);
  return async dispatch => {
    dispatch(fetchGlobalSearchStart());
    try {
      const response = await axios.get(`/common/global-search/${keyword.toLowerCase().replace(/\//g, '=')}`);
      // console.log('response.data', response.data);
      dispatch(getSearchGlobalSuccess(response));
      dispatch(fetchGlobalSearchEnd());
    } catch (error) {
      dispatch(fetchGlobalSearchEnd());
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getSearchGlobalSuccess = ({ data }) => {
  return {
    type: GET_GLOBAL_PARAMETER_SEARCH_SUCCESS,
    data
  };
};

export const searchGlobalAssetData = (keyword = '', isOnlyIOTAsset = false) => {
  // console.log('keyword =>', keyword);
  return async dispatch => {
    dispatch(fetchGlobalAssetSearchStart());
    try {
      const response = await axios.get(`/common/asset-search/${keyword.toLowerCase().replace(/\//g, '=')}${isOnlyIOTAsset ? '?is-only-iot-attached=' + isOnlyIOTAsset : ''}`);
      // console.log('response.data =>', response.data);
      const { data } = response;
      const assets = data && data.length && data.map(doc => doc.searchRecord) || [];
      dispatch(getSearchGlobalAssetSuccess(assets));
      dispatch(fetchGlobalAssetSearchEnd());
    } catch (error) {
      dispatch(fetchGlobalAssetSearchEnd());
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getSearchGlobalAssetSuccess = (data) => {
  return {
    type: GET_GLOBAL_ASSET_SEARCH_SUCCESS,
    data
  };
};

export const getApplicationModules = () => {
  // console.log('app mods--')
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/all-application-modules`);
      // console.log(response);
      dispatch(getApplicationModuleSuccess(response));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getApplicationModuleSuccess = ({ data }) => {
  return {
    type: GET_APPLICATION_MODULE_SUCCESS,
    data
  };
};

export const fetchAssetFiltersData = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/asset-filters`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetFiltersDataSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchAssetFiltersDataSuccess = (data) => {
  return {
    type: FETCH_ASSET_FILTERS_SUCCESS,
    data
  }
}

export const getBackgroundJobStatus = (jobId) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/common/job-status/${jobId}`);
      dispatch(getJobStatusSuccess(response.data));
    } catch (error) {
      console.log("Error****:", error);
    }
  }
};

export const getJobStatusSuccess = (data) => {
  return {
    type: GET_BACKGROUND_JOB_SUCCESS,
    data
  }
}





